export default __webpack_public_path__ + "static/media/bg-teens-smiling.a5754599.jpeg";